<div class="wrapper">
    <app-dialog-title
        [title]="title"
        (close)="close()"
    ></app-dialog-title>
    
    <mat-dialog-content>
        <div class="dialog-content">
            <span *ngIf="!hideIcon" class="icon" [ngClass]="getIconClass()"></span>
            <span class="text" [innerHTML]="body"></span>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button class="bciti-button no-transition bciti-button--blue" (click)="close()">
            {{ actionButtonText || ('common.close' | translate) }}
        </button>
    </mat-dialog-actions>
</div>
